import { LegalDocumentPage } from './LegalDocumentPage';
import { useI18n } from '@/hooks/useI18n';

export function PrivacyPage() {
  const { t } = useI18n();
  return (
    <LegalDocumentPage document={t.legal.ilumetria.privacidad} metaDescription={t.legal.meta.privacidad} />
  );
}

export function TermsPage() {
  const { t } = useI18n();
  return (
    <LegalDocumentPage document={t.legal.ilumetria.terminos} metaDescription={t.legal.meta.terminos} />
  );
}

export function CookiesPage() {
  const { t } = useI18n();
  return (
    <LegalDocumentPage document={t.legal.ilumetria.cookies} metaDescription={t.legal.meta.cookies} />
  );
}

export function BarbunnyPrivacyPage() {
  const { t } = useI18n();
  return (
    <LegalDocumentPage
      document={t.legal.barbunny.privacidad}
      metaDescription={t.legal.meta.barbunnyPrivacidad}
    />
  );
}

export function BarbunnyTermsPage() {
  const { t } = useI18n();
  return (
    <LegalDocumentPage
      document={t.legal.barbunny.terminos}
      metaDescription={t.legal.meta.barbunnyTerminos}
    />
  );
}
